<script lang="ts">
  import { Alert, AlertType } from '$shared/components';
  import { AlertOption } from '$provider/models/AlertOption';
  import type { EntityTab } from '../EntityViewProp';

  interface Props {
    message?: string | undefined;
    type?: string | undefined;
    tab?: EntityTab | undefined;
    activeTab?: string;
  }

  let {
    message = undefined,
    type = undefined,
    tab = undefined,
    activeTab = ''
  }: Props = $props();

  // if tab is null, alert shows for all tab
  // If any particular tab passed it only show that tab
  let show = $derived(!tab || tab === activeTab);
</script>

{#if show && message}
  <div class="comp-alert-info">
    <Alert maxWidth data={message} options={AlertOption.from(type || AlertType.Warn)} />
  </div>
{/if}

<style>
  .comp-alert-info {
    margin-bottom: 24px;
  }
</style>
